import { HelpMessage } from 'utils/constants'
import SubTable from '../SubTable'
import { SecondTableProps } from './types'

const SecondTable: React.FC<SecondTableProps> = ({
  concretePlacement,
  cureRate,
}) => {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Placements
  return (
    <SubTable
      concretePlacement={concretePlacement}
      which="second"
      columns={[
        {
          title: 'Cure Gallons',
          width: 120,
          help: help.CureGallons,
          render: 'cureGallons',
        },
        {
          title: 'Cure SqFt',
          width: 102,
          help: help.CureSqFt,
          render: 'cureSqft',
        },
        {
          title: 'Required Cure Rate (SqFt/Gal)',
          width: 231,
          help: help.RequiredCureRate,
          render: () => cureRate?.toFixed(1),
        },
        {
          title: 'Cure Rate (SqFt/Gal)',
          width: 171,
          help: help.CureRate,
          render: ({ cureSqft, cureGallons }) =>
            cureGallons && cureSqft ? (cureSqft / cureGallons).toFixed(1) : '',
        },
      ]}
    />
  )
}

export default SecondTable
